import Immutable from 'seamless-immutable'

import {
  PAIDLEAVE_SET_LOCATION
} from './actionTypes'

const initialState = Immutable({
  locations: {},
})

export default function State (state = initialState, action) {
  switch (action.type) {
    case PAIDLEAVE_SET_LOCATION:
      state = Immutable.setIn(state, ['locations', action.payload.location.id], action.payload.location)
      break

      default:
      break
  }

  return state
}
